import React from "react";

class DowntimeBanner extends React.Component {
    render() {
        let maybeUnderlineClass = this.props.href ? "underline" : null;
        let content = (
            <React.Fragment>
                <span className="show-sm">
                    <span className="info">
                        <span className={maybeUnderlineClass}>
                            Scheduled Downtime
                        </span>
                        : {this.props.dateString}.
                    </span>
                </span>
                <span className="show-lg">
                    <span className="info">
                        We'll be down for&nbsp;
                        <span className={maybeUnderlineClass}>
                            scheduled maintenance
                        </span>
                        &nbsp;on{" "}
                        {this.props.longDateString || this.props.dateString}.
                    </span>
                </span>
            </React.Fragment>
        );

        if (this.props.href) {
            content = (
                <a
                    className="no-decoration"
                    href={this.props.href}
                    title="More information"
                    target="_blank"
                >
                    {content}
                </a>
            );
        } else {
            content = <span className="content">{content}</span>;
        }

        return (
            <section
                className="banner banner-flex promo info site-only full-banner-link"
                data-callback={`accounts/hide-banner/${this.props.bannerKey}`}
                data-banner-show-anonymous="true"
                data-banner-key="downtime"
            >
                <div className="banner-grid row">
                    {content}
                    <span
                        className="dismiss-banner ui_close"
                        onClick={this.props.bannerDismiss}
                        title="Dismiss banner"
                    />
                </div>
            </section>
        );
    }
}

export default DowntimeBanner;
